import React from 'react';
import './Loader.css';

const WaveLoader = () => {
  return (
    <div className="wave-loader-wrapper">
      <div className="wave-loader-box">
        <img src="/images/loader/graylogo.png" alt="Grayscale Logo" className="grayscale-image" />
        <div className="colored-image" />
      </div>
    </div>
  );
};

export default WaveLoader;
